export interface ProgramPartsContext {
  mode:   'program' | 'jingle'
  isLive: boolean
}

/**
 * Les parties décrivent la structure éditoriale d'un programme. Le passage en
 * direct change son mode de diffusion, pas cette structure.
 */
export function canEditProgramParts({ mode }: ProgramPartsContext): boolean {
  return mode === 'program'
}
